import state from './state'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'

export const strict = false
export default {
  namespaced: true,
  scrict: false,
  state,
  getters,
  actions,
  mutations
}
